import React from 'react';
import { ReactComponent as SearchIconSvg } from '../../../img/default-svg/empty-search.svg';
import { useTranslation } from 'react-i18next';
import './style.scss';

const SwapWalletsEmpty = () => {
  const {t} = useTranslation();

  return (
    <div className="swap-wallets-empty">
      <div className="swap-wallets-empty__icon">
        <SearchIconSvg />
      </div>
      <div className="swap-wallets-empty__text">
        {t('swap.noWallets')}
      </div>
    </div>
  );
};

export default SwapWalletsEmpty;
